import { useMemo } from "react";
import { useAppSelector } from "../../../../app/hooks";
import {
  CANDIDATE_REJECTION_REASONS,
  CandidateRejectionReason,
} from "../../../types/CandidateRejectionReason";

export const useCandidateRejectionReasons = (): Record<
  CandidateRejectionReason,
  string
> => {
  const localized = useAppSelector(
    (state) => state.localized.candidateRejectionReason,
  );
  return useMemo(
    () =>
      Object.fromEntries(
        CANDIDATE_REJECTION_REASONS.map((reason) => [
          reason,
          localized?.[reason] ?? reason,
        ]),
      ) as Record<CandidateRejectionReason, string>,
    [localized],
  );
};
